import { render, staticRenderFns } from "./agreements_history_new_view.vue?vue&type=template&id=ff4acfee"
import script from "./agreements_history_new_view.vue?vue&type=script&lang=js"
export * from "./agreements_history_new_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports